import { Select, Space } from 'antd';
import SurveyGroupSelect from 'components/SurveyGroupSelect';
import useQuestionOptions from 'hooks/useQuestionOptions';
import useSurvey from 'hooks/useSurvey';
import React, { useEffect, useState } from 'react';

const SurveyOptionSelector = ({ value, onChange, customerId }) => {
  const [surveyId, setSurveyId] = useState();
  const [questionId, setQuestionId] = useState();

  const { survey } = useSurvey({ surveyId, extraFields: 'questions { id title options { id title } }' });

  const { options } = useQuestionOptions({ optionIds: value, extraFields: 'questions { id survey { id } }' });

  useEffect(() => {
    if (!questionId && options?.length) {
      setQuestionId(options[0]?.questions[0]?.id);
      setSurveyId(options[0]?.questions[0]?.survey?.id);
    }
  });

  const questionOptions = survey?.questions?.map((question) => ({ label: question.title, value: question.id }));
  const optionOptions = survey?.questions?.find((question) => question.id === questionId)?.options?.map((option) => ({ label: option.title, value: option.id }));

  return (
    <Space>
      <SurveyGroupSelect value={surveyId} onChange={setSurveyId} customerId={customerId} selectables={['survey']} showStatus={false} />
      <Select options={questionOptions} value={questionId} onChange={setQuestionId} style={{ minWidth: 200 }} />
      <Select options={optionOptions} value={value} onChange={onChange} style={{ minWidth: 200 }} mode="multiple" />
    </Space>
  );
};

export default SurveyOptionSelector;
